import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';

type ReportsPageEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const kbRequestsReportsPageEntryPoint: EntryPoint<ReportsPageEntryPointComponent, {}> = {
	root: JSResourceForUserVisible<ReportsPageEntryPointComponent>(
		/* webpackChunkName: "async-csm-reports-kb-requests-entrypoint" */
		'./KbRequestsReportsPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
};
